var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSearchIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 15,
    height: 15,
    viewBox: "0 0 15 15",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M9.5331 9.5331C9.94287 9.12333 10.2679 8.63687 10.4897 8.10149C10.7114 7.5661 10.8256 6.99228 10.8256 6.41279C10.8256 5.83329 10.7114 5.25947 10.4897 4.72409C10.2679 4.1887 9.94287 3.70224 9.5331 3.29248C9.12334 2.88271 8.63687 2.55767 8.10149 2.3359C7.5661 2.11414 6.99228 2 6.41279 2C5.83329 2 5.25947 2.11414 4.72409 2.3359C4.1887 2.55767 3.70224 2.88271 3.29248 3.29248C2.46492 4.12003 2 5.24244 2 6.41279C2 7.58313 2.46492 8.70554 3.29248 9.5331C4.12003 10.3607 5.24244 10.8256 6.41279 10.8256C7.58313 10.8256 8.70554 10.3607 9.5331 9.5331ZM9.5331 9.5331L12.3125 12.3125",
    stroke: "#DFDFDF",
    strokeWidth: 0.7,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSearchIcon);
export default __webpack_public_path__ + "static/media/searchIcon.fa9681b6ffd31311de643a6fb8c0c9ac.svg";
export { ForwardRef as ReactComponent };